export function formatUsd(amount: number): string {
  const rounded = Math.round(amount * 100) / 100
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2)
}

export function sumUsd(...amounts: number[]): number {
  return Math.round(amounts.reduce((acc, n) => acc + n, 0) * 100) / 100
}
